var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionWrapper',[_c('AuditFilters'),_c('AuditTable'),_c('AuditModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }